import { render, staticRenderFns } from "./PriceRuleWrapper.vue?vue&type=template&id=5bd91eb0&scoped=true&"
import script from "./PriceRuleWrapper.vue?vue&type=script&lang=js&"
export * from "./PriceRuleWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PriceRuleWrapper.vue?vue&type=style&index=0&id=5bd91eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd91eb0",
  null
  
)

export default component.exports